<script>
export default {
  name: 'PageNotFound',
  created() {
    window.location.href = '/not-found';
  },
};
</script>
